export const getMapFeature = state => state.map.feature;

export const getMapFeatureGeometry = state => state.map.feature?.geometry;
